<template>
  <div id="app">
	  <keep-alive>
		<router-view v-if="$route.meta.keepAlive"></router-view>
	</keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
	import { getCookie, setCookie,getToken,getAesString } from "@/utils/common.js";
	import axios from "axios";
	export default{
		name:"app",
		created(){

			sessionStorage.clear()
			localStorage.setItem("access_token", getCookie("access_token"));
			localStorage.setItem("shopId", getCookie("shopId"));
			localStorage.setItem("uniqueId", getCookie("uniqueId"));
			localStorage.setItem("version", getCookie("version"));
			localStorage.setItem("shopUserId", getCookie("shopUserId"));
			localStorage.setItem("shopName", getCookie("ShopName"));


			localStorage.removeItem("count")
			console.log("这里是app.vue中的created")
			window.watchs =function(){
			var _mtac = {"performanceMonitor":1};
			(function() {
				var mta = document.createElement("script");
				mta.src = "//pingjs.qq.com/h5/stats.js?v2.0.4";
				mta.setAttribute("name", "MTAH5");
				mta.setAttribute("sid", "500691820");
				mta.setAttribute("cid", "500691824");
				var s = document.getElementsByTagName("script")[0];
				s.parentNode.insertBefore(mta, s);
			})();
			}
			
			window.syncAuthor = function() {
			localStorage.setItem("access_token", getCookie("access_token"));
			localStorage.setItem("shopId", getCookie("shopId"));
			localStorage.setItem("uniqueId", getCookie("uniqueId"));
			localStorage.setItem("version", getCookie("version"));
			localStorage.setItem("shopUserId", getCookie("shopUserId"));
			localStorage.setItem("shopName", getCookie("ShopName"));
			};

		}
	}
	
	
	
</script>
<style lang="scss">
	@import "./css/reset.css";

	html{
		width: 100%;
		height: 100%;
	}
	body{
		width: 100%;
		height: 100%;
	}
#app {
  font-family:STXihei;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #333333;
	height: 100%;

}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
img{
	width: 100%;
	height: 100%;
}
.flex1{
	display: flex;
	align-items: center;
	justify-content: space-between
}
.flex2{
	display: flex;
	align-items: center;
}
.flex3{
	display: flex;
	align-items: flex-end;
}
::-webkit-input-placeholder { /* WebKit browsers */
  color: #B3B3B3;
}

::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #B3B3B3;
}

:-ms-input-placeholder { /* Internet Explorer 10+ */
  color: #B3B3B3;
}   
.pos1{
	position: relative;
}
.trans{
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
}
input[disabled],input:disabled,input.disabled{  
    color: #000;  
    -webkit-text-fill-color:#000;  
    -webkit-opacity:1;  
    opacity: 1;  
}
.line1{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
	word-break: break-all;
	word-wrap: break-word;
}
.line2{
	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	word-wrap: break-word;
}

</style>
